// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import CompanySubPage from '../../components/Company/CompanySubPage/CompanySubPage';
import DisplayBox from '../../components/DisplayBox/DisplayBox';
import Label from '../../ui-elements/Label/Label';
import CompanyAssetsTab from '../../components/Company/CompanyAssets/CompanyAssetsTab';
// Type imports:
import { ICompanyViewModel } from '../../types/CompanyTypes';

const CompanyPropertiesPage: React.FC<ICompanyViewModel> = ({
    id,
    isAuthenticated,
    isSubscriber
}) => {
    return (
        <Entrypoint>
            <CompanySubPage 
                id={id} 
                title='Fasteignir'
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
                component={
                    <DisplayBox
                        title='Fasteignir'
                        asideComponent={<Label text='FAST.SKR.' fullText="Fasteignaskrá" labelType='origin' />}
                    >
                        <CompanyAssetsTab
                            large
                            assetType='properties'
                            id={id}
                            isAuthenticated={isAuthenticated}
                        />
                    </DisplayBox>
                } 
                />
        </Entrypoint>
    );
}

export default CompanyPropertiesPage;